// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основные стили */
.personal-cabinet {
  background: transparent;
  padding: 0;
  overflow: hidden;
}

/* Шапка личного кабинета */
.pc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 0 8px;
}

.pc-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pc-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Кнопка обновления */
.pc-refresh-btn {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  color: #374151;
  padding: 10px 20px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  margin-right: 6px;
  margin-top: 4px;
}

.pc-refresh-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.pc-refresh-btn:disabled {
  background: #f1f5f9;
  border-color: #d1d5db;
  color: #a9aeb5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.pc-refresh-icon {
  width: 22px;
  height: 22px;
  transition: transform 0.3s ease;
}

.pc-refresh-spin {
  animation: pc-spin 1s linear infinite;
}

@keyframes pc-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Общие стили для кнопок */
.pc-edit-btn,
.pc-save-btn,
.pc-cancel-btn,
.pc-action-btn,
.pc-confirm-btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  border: none;
  text-align: center;
}

.pc-edit-btn,
.pc-save-btn,
.pc-confirm-btn {
  background: #002FA7;
  color: white;
}

.pc-edit-btn:hover,
.pc-save-btn:hover,
.pc-confirm-btn:hover:not(:disabled) {
  background: #1e40af;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);
}

.pc-save-btn {
  background: #10b981;
  min-width: 180px;
  height: 40px;
}

.pc-save-btn:hover {
  background: #059669;
}

.pc-cancel-btn {
  background: #ef4444;
  color: white;
  min-width: 180px;
  height: 40px;
}

.pc-cancel-btn:hover {
  background: #dc2626;
}

.pc-action-buttons {
  display: flex;
  gap: 12px;
}

.pc-action-btn {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  color: #475569;
  padding: 10px 16px;
}

.pc-action-btn:hover {
  background: #e2e8f0;
  color: #002FA7;
}

.pc-confirm-btn {
  min-width: 140px;
  position: relative;
  overflow: hidden;
}

.pc-confirm-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Контент */
.pc-content {
  padding: 8px 0;
}

/* Сообщения */
.pc-success-message {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 1px solid #10b981;
  color: #065f46;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 24px;
  font-weight: 500;
  border-left: 4px solid #10b981;
}

/* Информационная сетка */
.pc-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.pc-info-group {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}

.pc-info-group h3 {
  color: #002FA7;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.pc-info-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.pc-info-item:last-child {
  margin-bottom: 0;
}

.pc-info-item label {
  color: #64748b;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 6px;
}

.pc-info-item span {
  color: #1e293b;
  font-size: 15px;
  font-weight: 500;
}

/* Поля ввода */
.pc-input,
.pc-textarea {
  padding: 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 15px;
  color: #1e293b;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
  font-family: inherit;
}

.pc-input:focus,
.pc-textarea:focus {
  outline: none;
  border-color: #5986f7;
  box-shadow: 0 0 0 3px rgba(89, 134, 247, 0.1);
}

.pc-input::placeholder,
.pc-textarea::placeholder {
  color: #9ca3af;
}

.pc-input:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}

.pc-input:required {
  border-left: 3px solid #3b82f6;
}

.pc-input:invalid {
  border-color: #ef4444;
}

.pc-textarea {
  resize: vertical;
  min-height: 80px;
}

.pc-readonly {
  color: #6b7280;
}

/* Дополнительные действия */
.pc-additional-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  border-top: 1px solid #e2e8f0;
  padding-top: 24px;
}

/* Модальное окно */
.pc-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(50, 64, 124, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: pc-fadeIn 0.2s ease;
}

@keyframes pc-fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.pc-modal {
  background: white;
  border-radius: 12px;
  padding: 0;
  width: 90%;
  max-width: 450px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  animation: pc-modal-appear 0.2s ease-out;
}

@keyframes pc-modal-appear {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.pc-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border-radius: 12px 12px 0 0;
  color: white;
}

.pc-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: white;
}

.pc-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  padding: 4px 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.pc-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.pc-modal-content {
  padding: 24px;
}

.pc-form-group {
  margin-bottom: 20px;
}

.pc-form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}

.pc-form-group label::after {
  content: " *";
  color: #ef4444;
}

.pc-modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f3f4f6;
}

/* Загрузка */
.pc-loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s ease-in-out infinite;
  margin-right: 8px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Дополнительные элементы */
.pc-edit-notice {
  background-color: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 6px;
  padding: 12px 16px;
  margin-top: 20px;
  color: #0369a1;
  font-size: 14px;
}

.pc-password-strength {
  margin-top: 8px;
  font-size: 12px;
  color: #6b7280;
}

.pc-password-requirements {
  margin-top: 12px;
  padding: 12px;
  background-color: #f8fafc;
  border-radius: 6px;
  border-left: 4px solid #3b82f6;
}

.pc-password-requirements h4 {
  margin: 0 0 8px 0;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.pc-password-requirements ul {
  margin: 0;
  padding-left: 16px;
  color: #6b7280;
}

.pc-password-requirements li {
  margin-bottom: 4px;
  font-size: 11px;
}

/* Адаптивность */
@media (max-width: 768px) {
  .pc-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .pc-info-grid {
    grid-template-columns: 1fr;
  }
  
  .pc-action-buttons {
    width: 100%;
    justify-content: flex-end;
  }
  
  .pc-additional-actions {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .pc-modal {
    width: 95%;
    margin: 20px;
  }
  
  .pc-modal-header {
    padding: 20px 20px 16px;
  }
  
  .pc-modal-content {
    padding: 20px;
  }
  
  .pc-modal-actions {
    flex-direction: column;
    gap: 12px;
  }
  
  .pc-confirm-btn {
    width: 100%;
    min-width: auto;
  }
}

@media (max-width: 480px) {
  .pc-content {
    padding: 16px;
  }
  
  .pc-info-group {
    padding: 16px;
  }
  
  .pc-action-buttons {
    flex-direction: column;
  }
  
  .pc-edit-btn,
  .pc-save-btn,
  .pc-cancel-btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/st-components/PersonalCabinetStyle.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,2BAA2B;AAC3B;;;;;EAKE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;EAGE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;EACb;AACF","sourcesContent":["/* Основные стили */\n.personal-cabinet {\n  background: transparent;\n  padding: 0;\n  overflow: hidden;\n}\n\n/* Шапка личного кабинета */\n.pc-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 0 8px;\n}\n\n.pc-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.pc-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Кнопка обновления */\n.pc-refresh-btn {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid #e2e8f0;\n  color: #374151;\n  padding: 10px 20px;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n  margin-right: 6px;\n  margin-top: 4px;\n}\n\n.pc-refresh-btn:hover:not(:disabled) {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.pc-refresh-btn:disabled {\n  background: #f1f5f9;\n  border-color: #d1d5db;\n  color: #a9aeb5;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.pc-refresh-icon {\n  width: 22px;\n  height: 22px;\n  transition: transform 0.3s ease;\n}\n\n.pc-refresh-spin {\n  animation: pc-spin 1s linear infinite;\n}\n\n@keyframes pc-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Общие стили для кнопок */\n.pc-edit-btn,\n.pc-save-btn,\n.pc-cancel-btn,\n.pc-action-btn,\n.pc-confirm-btn {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n  border: none;\n  text-align: center;\n}\n\n.pc-edit-btn,\n.pc-save-btn,\n.pc-confirm-btn {\n  background: #002FA7;\n  color: white;\n}\n\n.pc-edit-btn:hover,\n.pc-save-btn:hover,\n.pc-confirm-btn:hover:not(:disabled) {\n  background: #1e40af;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.2);\n}\n\n.pc-save-btn {\n  background: #10b981;\n  min-width: 180px;\n  height: 40px;\n}\n\n.pc-save-btn:hover {\n  background: #059669;\n}\n\n.pc-cancel-btn {\n  background: #ef4444;\n  color: white;\n  min-width: 180px;\n  height: 40px;\n}\n\n.pc-cancel-btn:hover {\n  background: #dc2626;\n}\n\n.pc-action-buttons {\n  display: flex;\n  gap: 12px;\n}\n\n.pc-action-btn {\n  background: #f1f5f9;\n  border: 1px solid #cbd5e1;\n  color: #475569;\n  padding: 10px 16px;\n}\n\n.pc-action-btn:hover {\n  background: #e2e8f0;\n  color: #002FA7;\n}\n\n.pc-confirm-btn {\n  min-width: 140px;\n  position: relative;\n  overflow: hidden;\n}\n\n.pc-confirm-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Контент */\n.pc-content {\n  padding: 8px 0;\n}\n\n/* Сообщения */\n.pc-success-message {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  border: 1px solid #10b981;\n  color: #065f46;\n  padding: 16px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  font-weight: 500;\n  border-left: 4px solid #10b981;\n}\n\n/* Информационная сетка */\n.pc-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.pc-info-group {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.pc-info-group h3 {\n  color: #002FA7;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.pc-info-item {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n}\n\n.pc-info-item:last-child {\n  margin-bottom: 0;\n}\n\n.pc-info-item label {\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 400;\n  margin-bottom: 6px;\n}\n\n.pc-info-item span {\n  color: #1e293b;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n/* Поля ввода */\n.pc-input,\n.pc-textarea {\n  padding: 8px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #1e293b;\n  transition: all 0.2s ease;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.pc-input:focus,\n.pc-textarea:focus {\n  outline: none;\n  border-color: #5986f7;\n  box-shadow: 0 0 0 3px rgba(89, 134, 247, 0.1);\n}\n\n.pc-input::placeholder,\n.pc-textarea::placeholder {\n  color: #9ca3af;\n}\n\n.pc-input:disabled {\n  background-color: #f9fafb;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.pc-input:required {\n  border-left: 3px solid #3b82f6;\n}\n\n.pc-input:invalid {\n  border-color: #ef4444;\n}\n\n.pc-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.pc-readonly {\n  color: #6b7280;\n}\n\n/* Дополнительные действия */\n.pc-additional-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 24px;\n}\n\n/* Модальное окно */\n.pc-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(50, 64, 124, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  animation: pc-fadeIn 0.2s ease;\n}\n\n@keyframes pc-fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.pc-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 0;\n  width: 90%;\n  max-width: 450px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  animation: pc-modal-appear 0.2s ease-out;\n}\n\n@keyframes pc-modal-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.pc-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border-radius: 12px 12px 0 0;\n  color: white;\n}\n\n.pc-modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: white;\n}\n\n.pc-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: white;\n  padding: 4px 8px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.pc-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.pc-modal-content {\n  padding: 24px;\n}\n\n.pc-form-group {\n  margin-bottom: 20px;\n}\n\n.pc-form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #374151;\n  font-size: 14px;\n}\n\n.pc-form-group label::after {\n  content: \" *\";\n  color: #ef4444;\n}\n\n.pc-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #f3f4f6;\n}\n\n/* Загрузка */\n.pc-loading-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid #ffffff;\n  border-radius: 50%;\n  border-top-color: transparent;\n  animation: spin 1s ease-in-out infinite;\n  margin-right: 8px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Дополнительные элементы */\n.pc-edit-notice {\n  background-color: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 6px;\n  padding: 12px 16px;\n  margin-top: 20px;\n  color: #0369a1;\n  font-size: 14px;\n}\n\n.pc-password-strength {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.pc-password-requirements {\n  margin-top: 12px;\n  padding: 12px;\n  background-color: #f8fafc;\n  border-radius: 6px;\n  border-left: 4px solid #3b82f6;\n}\n\n.pc-password-requirements h4 {\n  margin: 0 0 8px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.pc-password-requirements ul {\n  margin: 0;\n  padding-left: 16px;\n  color: #6b7280;\n}\n\n.pc-password-requirements li {\n  margin-bottom: 4px;\n  font-size: 11px;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .pc-header {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n  }\n  \n  .pc-info-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .pc-action-buttons {\n    width: 100%;\n    justify-content: flex-end;\n  }\n  \n  .pc-additional-actions {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 640px) {\n  .pc-modal {\n    width: 95%;\n    margin: 20px;\n  }\n  \n  .pc-modal-header {\n    padding: 20px 20px 16px;\n  }\n  \n  .pc-modal-content {\n    padding: 20px;\n  }\n  \n  .pc-modal-actions {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .pc-confirm-btn {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .pc-content {\n    padding: 16px;\n  }\n  \n  .pc-info-group {\n    padding: 16px;\n  }\n  \n  .pc-action-buttons {\n    flex-direction: column;\n  }\n  \n  .pc-edit-btn,\n  .pc-save-btn,\n  .pc-cancel-btn {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
